import { useQuery } from '@tanstack/react-query';
import { VisualizationRanksApi } from '@/lib/api/loop-visualization/visualization-ranks';
import { loopVisualizationQueryKeys } from '@/lib/query-keys/loop-visualizations';

export const useVisualizationItemRanks = ({
  viewId,
  visualizationId,
  enabled = true,
}: {
  viewId: number;
  visualizationId: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: loopVisualizationQueryKeys.itemRanks.detail(viewId, visualizationId),
    queryFn: async () => {
      const entries = await VisualizationRanksApi.getItemRanks(viewId, visualizationId);
      const map = new Map<number, string>();
      for (const entry of entries) {
        map.set(entry.itemId, entry.rank);
      }
      return map;
    },
    enabled,
    refetchOnMount: false,
  });
};
